import classNames from 'classnames';
import React from 'react';
import { LoadingButton } from '../LoadingButton';
import { ButtonType } from '../../utils/types/SetupPages/ButtonValue';
import { ButtonValue } from '../../utils/types/SetupPages/ButtonType';

interface PropTypes {
  firstItem: SetupFooterButtonType;
  lastItem?: SetupFooterButtonType;
  classNames?: string;
}

export interface SetupFooterButtonType {
  title: React.ReactNode;
  action?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  isLoading?: boolean;
  type: ButtonType;
  value?: ButtonValue;
}

function FirstItemFooter(props: { item: SetupFooterButtonType }) {
  return (
    <LoadingButton
      color='primary'
      type={props.item.type === 'Save' ? 'submit' : 'button'}
      onClick={props.item.action ? props.item.action : undefined}
      disabled={props.item.disabled}
      value={props.item.value}
      isLoading={props.item.isLoading}
    >
      {props.item.title}
    </LoadingButton>
  );
}

function LastItemFooter(props: { item?: SetupFooterButtonType }) {
  if (props.item == null) {
    return null;
  }

  return (
    <LoadingButton
      color={props.item.type === 'Cancel' ? 'danger' : 'secondary'}
      type={props.item.type === 'Save' ? 'submit' : 'button'}
      onClick={props.item.action || null}
      disabled={props.item.disabled}
      value={props.item.value}
      isLoading={props.item.isLoading}
    >
      {props.item.title}
    </LoadingButton>
  );
}

export function SetupPageFooter(props: PropTypes) {
  return (
    <div
      className={classNames('d-flex gap-3 align-items-start', props.classNames)}
    >
      <FirstItemFooter item={props.firstItem} />
      <LastItemFooter item={props.lastItem} />
    </div>
  );
}
